import Backend from './backends/auto';
import Rangers from './rangers';
export { BreadcrumbType, ReportEventType } from './types';
var rangers = new Rangers({
    Backend: Backend,
});
export default rangers;
//# sourceMappingURL=index.js.map